import { useQuery } from '@tanstack/react-query'
import { getAuthenticatedUserProfile } from '@/services/api'

/** Whether the caller is the root organization. Partners are admin-eligible but not root. */
export function useIsRootOrganization() {
  const { data: profile, isLoading } = useQuery({
    queryKey: ['user-profile'],
    queryFn: getAuthenticatedUserProfile,
  })
  return { isRoot: profile?.user.organization.root_organization ?? false, isLoading }
}
